import { inject, Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { LoadingService } from '@portal/loading/data-access';
import { catchError, finalize, switchMap, tap, throwError } from 'rxjs';
import { ApplicationApiService } from '../api/application-api.service';
import { ROUTE } from '../constant/route.constant';
import { RouteErrorCode } from '../type/route.type';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class LetterOfOfferResolver implements Resolve<string> {
  private readonly applicationApi = inject(ApplicationApiService);
  private readonly loadingService = inject(LoadingService);
  private readonly router = inject(Router);

  resolve() {
    this.loadingService.show();

    const pollCheckLetterOfOffer$ = this.applicationApi
      .pollApiCheckLetterOfOfferUntilAssigned({
        attempt: 30,
        interval: 2000,
      })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          this.navigateErrorPage('405');
          return throwError(() => error);
        }),
      );

    return pollCheckLetterOfOffer$.pipe(
      switchMap(() => this.applicationApi.getSignToken()),
      tap(accessToken =>
        this.router.navigate([ROUTE.E_SIGN.MAIN], {
          queryParams: { accessToken, config: JSON.stringify({ menu: { hide: true }, utm_source: 'flexipay_esign' }) },
        }),
      ),
      finalize(() => this.loadingService.hide()),
    );
  }

  private navigateErrorPage(errorCode?: RouteErrorCode): void {
    this.router.navigate([ROUTE.ERROR.MAIN, errorCode].filter(Boolean));
  }
}
